// extracted by mini-css-extract-plugin
module.exports = {"disabled":"_1Dwg0","link":"_37kN4"};